import React, { useContext } from 'react';
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LoginHeader from '../../components/Headers/LoginHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import LoginFooter from '../../components/Footers/LoginFooter';
import Search from '../../components/Search';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const SearchPage = () => {
  const { isLoggedIn, user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {isLoggedIn ? (role === "admin" ? <AdminHeader /> : <LoginHeader />) : <LogoutHeader />}
      <main>
        <Search />
      </main>
      {isLoggedIn ? <LoginFooter /> : <LogoutFooter />}
    </>
  );
}

export default SearchPage;